import React, { useEffect, useState } from "react";
import { Toast } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { hideToast } from "../../store/features/toast/toastSlice";

const ToastComponent = () => {
  const toast = useSelector((state) => state.toast);
  const boldMsgMatch = toast?.message?.match(/“([^”]*)”/);
  const boldMsg = boldMsgMatch ? boldMsgMatch[1] : "";

  let newStr = toast?.message;
  if (boldMsg) {
    newStr = newStr.replace(boldMsg, boldMsg);
  }

  const [showToast, setShowToast] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setShowToast(toast.show);
  }, [toast.show]);

  let toastClass;
  let iconClass = toast.customClass;

  if (toast.type === "success") {
    toastClass = "success-txt";
    iconClass = "mdi-check-circle";
  } else if (toast.type === "error") {
    toastClass = "error-txt";
    iconClass = "mdi-information";
  } else if (toast.type === "warning") {
    toastClass = "warning-txt";
    iconClass = "mdi-alert-circle-outline";
  } else {
    toastClass = "";
  }

  const messageParts = newStr?.split(boldMsg);

  return (
    <Toast
      onClose={() => {
        setShowToast(false);

        setTimeout(() => {
          dispatch(hideToast());
        }, 1000);
      }}
      className={toastClass}
      delay={3000}
      show={showToast}
      autohide
    >
      <div className="tostcenter">
        <div className="Tost_Content">
          <i className={`mdi ${iconClass}`}></i>
          <div className="txtcontain">
            {messageParts?.map((part, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <strong>{boldMsg}</strong>}
                {part}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </Toast>
  );
};

export default ToastComponent;
